import { Component, inject, signal } from '@angular/core';
import { Button } from 'primeng/button';
import { FormsModule } from '@angular/forms';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { TextareaModule } from 'primeng/textarea';
import { PdfService } from '../../service/pdf.service';
import { FileUpload, FileUploadModule } from 'primeng/fileupload';
import { FileProcess } from '@/util/fileProcess';
import { UserInteractiveService } from '@/Services/user-interactive.service';
import { LoadingService } from '@/shared/components/general/loading/service/loading.service';
import { TypeMessage } from '@/common/enums/general/TypeMessage';
import { EFileType } from '@/shared/components/general/file-preview/file-preview.component';

@Component({
  selector: 'app-modal-upload-file',
  standalone: true,
  imports: [Button, FormsModule, TextareaModule, FileUpload, FileUploadModule],
  templateUrl: './modal-upload-file.component.html',
  styleUrl: './modal-upload-file.component.scss',
})
export class ModalUploadFileComponent {
  refDialogService = inject(DynamicDialogRef);
  configDialogService = inject(DynamicDialogConfig);
  pdfService = inject(PdfService);
  loadingService = inject(LoadingService);
  userInteractiveService = inject(UserInteractiveService); 

  // parametros
  idfdArchivo = 0;
  uploadedFiles = signal<File[]>([])

  constructor() {
    this.idfdArchivo = this.configDialogService.data;
  } 

  onSelect(event: any) {
    this.uploadedFiles.set(event.currentFiles);
  }

  async uploadHandler(event: any) {
    this.loadingService.show();

    const file = this.uploadedFiles()[0];
    const filebase64 = await FileProcess.getBase64(file);
    const extension = '.' + (file.name.split('.').pop() || '');
    if (filebase64) {
      const data = await this.pdfService.addFile(this.idfdArchivo, filebase64, extension);
      this.refDialogService.close(data);
    }
    else {
      this.userInteractiveService.sendMessage(TypeMessage.ERROR, 'Ocurrio un error al procesar el archivo');
    }

    this.loadingService.hide();
  }

  onClear(event: any) {
    this.uploadedFiles.set([])
  }
}
